<template>
    <div>
        <el-upload
                :action="uploadUrl"
                :headers="{'Authorization':api_token}"
                :file-list="fileList"
                :show-file-list="false"
                accept=".pdf, .png, .jpg, .jpeg"
                :before-upload="beforeUpload"
                :on-progress="onProgress"
                :on-success="uploadedFile"
                :on-error="onError">
            <el-button
                    size="small"
                    type="primary"
                    v-text="buttonText">
            </el-button>
        </el-upload>
    </div>
</template>
<script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    export default {
        mounted(){
            this.uploadUrl = '/api/uploadFile/1';
            this.api_token = 'Bearer ' + window.sessionStorage.getItem('acquisition_token');
        },
        props:{
            buttonName:{
            },
            index:{
            },
        },
        data() {
            return {
                fileList: [],
                uploadUrl:"",
                api_token:""
            };
        },
        computed: {
            ...mapGetters('form', {
                catalogs: 'catalogs',
                requestForm: "requestForm",
                //onlyRead: "onlyRead"
            }),
            ...mapGetters(["userInfo"]),
            buttonText:{
                get:function(){
                    const DEFAULT_BUTTON_TEXT = "Clic para subir archivo";
                    if(!this.buttonName){
                        return DEFAULT_BUTTON_TEXT;
                    }
                    return this.buttonName
                }
            }
        },

        methods: {
            beforeUpload(file) {
                let _this = this;
                let isPDF = false;
                if (file.type === 'image/jpeg' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/x-png' ||
                    file.type === 'image/png' ||
                    file.type === 'application/pdf'
                ) {
                    isPDF = true;
                }

                const isLt2M = file.size / 1024 / 1024 < 5;

                if (!isPDF) {
                    this.$message.error('Sólo se permiten documentos en formato PDF e imagen');
                }

                if (!isLt2M) {
                    this.$message.error('Los archivos de documentos no pueden exceder los 5MB');
                }
                if(isPDF && isLt2M){
                    _this.$store.dispatch('loading/spinner', { msg: 'Subiendo archivo...', status: true }, { root: true });
                }

                return isPDF && isLt2M;
            },
            uploadedFile(data){
                if(this.index!=undefined){
                    data.index = this.index;
                }
                this.$emit('fileInfo', data);
            },
            onError(err, file, fileList){
                this.$Progress.fail();
                console.log(err);
            },
            onProgress(event, file, fileList){
                let _this = this;
                this.$Progress.set(event.percent);
                if(event.percent==100){
                    setTimeout(() => {
                        _this.$store.dispatch('loading/spinner', {}, { root: true });
                        this.$Progress.finish();
                    }, 500);
                }
            }
        }
    }
</script>
<style>

    .el-upload > input{
        height: 100%;
        width: 100%;
        opacity: 0;
        cursor: pointer;
    }

</style>
